import templateUrl from 'emun.salesrep/show-daily-comparison.htm'
import salesrepConfig from 'emun.salesrep/salesrep.config'
import AutoQuery from 'servicestack/auto-query/auto-query'

class ShowDailyComparisonController {
    constructor($window, $rootScope, retailerPrompt, createAutoQuery) { 
        let $ctrl = this;
        var context = $ctrl.context || 'rep';

		$ctrl.year = $ctrl.market.year; //new Date().getFullYear();
		$ctrl.lastyear = new Date().getFullYear() - 1;
		$ctrl.numAppointmentsGoal = 0;
		$ctrl.dollarAmountGoal = 0;

        this.activities = {
            total: 0,
            count: 0
        };

		$ctrl.vendor = {
			id: "ALL",
			label: "ALL"
		};

		$ctrl.chartData = [];
		$ctrl.chartLabels = [];
		$ctrl.tytotals = [];
		$ctrl.lytotals = [];
		$ctrl.totalDollar = 0;
		$ctrl.totalCount = 0;
		$ctrl.totalAvg = 0;
		$ctrl.chartSeries = [$ctrl.year];
		$ctrl.dollarAmountGoal = 0;

		$ctrl.loadChartData = function (args) {
			$ctrl.thisYear = new AutoQuery({
				url: 'QueryMarketDailyTotals.json?showCode=' + $ctrl.market.showCode + '&year=' + $ctrl.year,
				criteria: {
					"Vendor": $ctrl.vendor.label
				},
				autoLoad: true,
				pageSize: 1000,
				onLoaded: function (args) {
					$ctrl.tytotals = [];
					$ctrl.chartLabels = [];
					$ctrl.totalDollar = 0;
					$ctrl.totalCount = 0;
					$ctrl.totalAvg = 0;
					$ctrl.tygoals = [];
					$ctrl.dollarAmountGoal = 0;
					args.results.forEach(function (total) {
//						$ctrl.chartLabels.push(moment(total.showDate).format("ddd") + " Day " + total.dayNum);
						$ctrl.chartLabels.push(moment.utc(total.showDate).format("dddd"));
						$ctrl.tytotals.push(Math.round(total.salesTotal));
						$ctrl.totalDollar = $ctrl.totalDollar + total.salesTotal;
						$ctrl.totalCount = $ctrl.totalCount + total.salesCount;
					});
					$ctrl.totalAvg = Math.round($ctrl.totalDollar / $ctrl.totalCount);
					$ctrl.lastYearQuery = new AutoQuery({
						url: 'QueryMarketDailyTotals.json?showCode=' + $ctrl.market.showCode + '&year=' + $ctrl.lastyear,
						criteria: {
							"Vendor": $ctrl.vendor.label
						},
						autoLoad: true,
						pageSize: 1000,
						onLoaded: function (args) {
							$ctrl.lytotals = [];
							args.results.forEach(function (total) {
								$ctrl.lytotals.push(Math.round(total.salesTotal));
							});
							$ctrl.chartData = [];
							$ctrl.chartData.push($ctrl.lytotals);
							$ctrl.chartData.push($ctrl.tytotals);
							$ctrl.chartLoaded = true;
							$ctrl.customerQuery = new AutoQuery({
								url: 'QueryMarketCustomerDailyTotals.json?showCode=' + $ctrl.market.showCode + '&year=' + $ctrl.year,
								criteria: {
									"Vendor": $ctrl.vendor.label
								},
								autoLoad: true,
								pageSize: 1000,
								onLoaded: function (args) {
									$ctrl.uniqueCustomers = 0
									args.results.forEach(function (total) {
										$ctrl.uniqueCustomers = $ctrl.uniqueCustomers + total.customerCount;
									});
								}
							});
							$ctrl.showDollarGoals = createAutoQuery({
								url: 'QueryShowGoals.json?showCode=' + $ctrl.market.showCode + '&year=' + $ctrl.year + '&Sum=DollarAmount&GroupBy=ShowCode,Day',
								criteria: {
									"VendorId": $ctrl.vendor.id
								},
								autoLoad: true,
								pageSize: 1000,
								onLoaded: function (args) {
									args.results.forEach(function (total) {
										$ctrl.tygoals.push(total.sumDollarAmount);
										$ctrl.dollarAmountGoal += total.sumDollarAmount;
									});
									$ctrl.chartData.push($ctrl.tygoals);
								}
							});
						}
					});
				}
			});
		}

		$ctrl.vendors = new AutoQuery({
			url: 'QueryVendors.json?Active=1',
			orderBy: 'Label',
			onLoaded: function (args) {
				args.results.splice(0,0,{ id: "ALL", label: "ALL" });
			},
			autoLoad: true,
			pageSize: 100
		});


		$ctrl.colors = salesrepConfig.chartColors;

		$ctrl.chartOptions = {
			maintainAspectRatio: false,
			legend: {
                display: true,
                labels: {
                    boxWidth: 5,
                    fontSize: 10
                }
            },
            elements: {
                rectangle: {
                    borderWidth: 1
                }
            },
			scales: {
				yAxes: [{
					display: true,
					ticks: {
						callback: function (value, index, values) {
							return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
						},
						fontSize: 11
					}
				}]
			},
			tooltips: {
				enabled: true,
				callbacks: {
					label: function (tooltipItem, data) {
						var label = data.datasets[tooltipItem.datasetIndex].label;
						var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
						return label + ": $" + datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
						//                        return label + ': ' + $filter('currency')(datasetLabel);
					}
				}
			},
		}
        $ctrl.chartColors = ['#5EBEBC', '#EB474A', '#F6B25F', '#DBDBDB', '#9ABACB'];

		$ctrl.datasetOverride = [
			{
				label: $ctrl.lastyear,
				borderWidth: 1,
				type: 'bar'
			},
			{
				label: $ctrl.year,
				borderWidth: 1,
				hoverBackgroundColor: "rgba(255,99,132,0.4)",
				hoverBorderColor: "rgba(255,99,132,1)",
				type: 'line'
			},
			{
				label: "Goal",
				borderWidth: 1,
				hoverBackgroundColor: "rgba(255,99,132,0.4)",
				hoverBorderColor: "rgba(255,99,132,1)",
				type: 'line'
			}
		];
		$ctrl.loadChartData();

    }
	refresh() {
		let $ctrl = this;
		return $ctrl.loadChartData();
	}
}

let ShowDailyComparison = {
    bindings: {
        rep: '<',
		context: '@',
		showcode: '@',
		market: '<'
    },
	controller: ShowDailyComparisonController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}


export default ShowDailyComparison